import { FlexBox, Icon, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { capitalize } from 'lodash'
import { useStats } from '../../../lib/ctx/stats'
import { StatsPrivacy } from '../../../lib/types'

export const StatsPrivacySelector = () => {
  const { colors } = useTheme()
  const [privacy, updatePrivacy] = useStats((s) => [s.privacy, s.updatePrivacy])

  const menuItems = [
    {
      label: 'Public',
      value: 'everyone',
    },
    {
      label: 'Private',
      value: 'me',
    },
  ]

  const handleSelectPrivacy = async (privacy: StatsPrivacy) => {
    await updatePrivacy(privacy)
  }

  return (
    <div>
      <Text
        className={css`
          padding: 0 12px;
        `}
        type="label"
        sizing="L"
        color={colors.uiPewterGrey}
      >
        Choose your privacy setting
      </Text>
      <ul
        className={css`
          margin-top: 5px;
        `}
      >
        {menuItems.map((item) => {
          const value = item.value
          const selected = value === privacy

          return (
            <li
              key={value}
              className={css`
                padding: 0 20px 0 12px;
                height: 32px;
                display: flex;
                align-items: center;
                cursor: pointer;
              `}
              onClick={(e) => {
                e.stopPropagation()
                handleSelectPrivacy(value as StatsPrivacy)
              }}
            >
              <FlexBox
                className={css`
                  width: 100%;
                `}
                as="span"
                alignItems="center"
                gap="8px"
              >
                <Text type="body" sizing="M" color={colors.uiWhite}>
                  {capitalize(item.label)}
                </Text>
              </FlexBox>
              <Icon
                className={css`
                  flex-shrink: 0;
                  opacity: ${selected ? 1 : 0};
                `}
                type="tick"
                fill={colors.uiWhite}
              />
            </li>
          )
        })}
      </ul>
    </div>
  )
}
